<div class="container">
  <p class="text-center fs-3">Vert.x rest</p>    
  <p class="text-center fs-4">Consulta reactiva con httpResource</p>  
  <div class="d-flex">
    <button type="submit" class="btn btn-primary" (click)="onLeerFichero()">Leer fichero pequeño</button>    
  </div>
  <div class="row">
    <!-- <span class="textarea" role="textbox" id="resultado" > <pre>{{ leerFicheroResourceValue() }}</pre></span> -->
     <textarea class="form-control" id="leerFicheroTextArea" rows="5">{{ leerFicheroResourceValue() }}</textarea>
  </div>
  <div class="d-flex">
    <button type="submit" class="btn btn-primary" (click)="onLeerFicheroGrande()">Leer fichero grande</button>    
  </div>
  <div class="row">
    <!-- <span class="textarea" role="textbox" id="resultado" > <pre>{{ leerFicheroResourceValue() }}</pre></span> -->
     <textarea class="form-control" id="leerFicheroGrandeTextArea" rows="5">{{ leerFicheroGrandeResourceValue() }}</textarea>
  </div>

  <div class="d-flex">
    <button type="submit" class="btn btn-primary" (click)="onBus()">Event Bus</button>
    <input type="text" id="event_bus" class="form-control" [formControl]="eventBusName"> 
  </div>
  <div class="row">
    <!-- <span class="textarea" role="textbox" id="resultado" > <pre>{{ leerFicheroResourceValue() }}</pre></span> -->
     <textarea class="form-control" id="eventBusTextArea" rows="1">{{ eventBusResource() }}</textarea>
  </div>
    <div class="d-flex">
    <button type="submit" class="btn btn-primary" (click)="onExternalService()">External Service</button>
    <input type="text" id="event_bus" class="form-control" [formControl]="externalServiceURL"> 
  </div>
  <div class="row">
    <!-- <span class="textarea" role="textbox" id="resultado" > <pre>{{ leerFicheroResourceValue() }}</pre></span> -->
     <textarea class="form-control" id="externalServiceTextArea" rows="1">{{ externalServiceResource() }}</textarea>
  </div>
</div>
